export default "__VITE_ASSET__8_ZIcZ$r__"